import Vue from 'vue';
import i18n from "@/i18n";
// import vuetify from './plugins/vuetify';

function maxValue(){
  return 99999999;
}
function setMaxValue(num) {
  return i18n.t(num, [maxValue()])
}
Vue.filter('setMaxValue', setMaxValue);

function getDayStart() {
  var from = new Date();
  from.setHours(0, 0, 0, 0);
  return from;
}
function getDayEnd() {
  var end = new Date();
  end.setHours(23, 59, 59, 999);
  return end;
}

var cancelFlgs = [
  {
    text: i18n.t("CancelFlgs.off"),
    color: "primary",
    textColor: "white",
    value: 0
  },
  {
    text: i18n.t("CancelFlgs.on"),
    color: "grey",
    textColor: "white",
    value: 1
  }
];
// 查找cancelFlgs
function cancelFlgsItem(value) {
  value = value ? 1 : 0;// 有值都当on
  return cancelFlgs.find((element) => element.value == value);
}
function cancelFlgsText(value) {
  return cancelFlgsItem(value).text;
}
Vue.filter('cancelFlgsText', cancelFlgsText);
function cancelFlgsColor(value) {
  return cancelFlgsItem(value).color;
}
Vue.filter('cancelFlgsColor', cancelFlgsColor);
function cancelFlgsTextColor(value) {
  return cancelFlgsItem(value).textColor;
}
Vue.filter('cancelFlgsTextColor', cancelFlgsTextColor);

// 退货单状态
var returnOrderStatus = [
  {
    text: i18n.t("ReturnOrder.status.new"),
    color: "primary",
    textColor: "white",
    value: 1,
  },
  {
    text: i18n.t("ReturnOrder.status.confirmed"),
    color: "primary",
    textColor: "white",
    value: 2,
  },
  {
    text: i18n.t("ReturnOrder.status.granted"),
    color: "primary",
    textColor: "white",
    value: 3,
  },
  {
    text: i18n.t("ReturnOrder.status.finished"),
    color: "primary",
    textColor: "white",
    value: 4,
  },
];
// 查找Status
function returnOrderStatusItem(value) {
  var item = returnOrderStatus.find((element) => element.value == value);
  return item ? item : {
    text: i18n.t("Status.unkown"),
    color: "gray",
    textColor: "white",
    value: "",
  };
}
function returnOrderStatusText(value) {
  return returnOrderStatusItem(value).text;
}
Vue.filter('returnOrderStatusText', returnOrderStatusText);
function returnOrderStatusColor(value) {
  return returnOrderStatusItem(value).color;
}
Vue.filter('returnOrderStatusColor', returnOrderStatusColor);
function returnOrderStatusTextColor(value) {
  return returnOrderStatusItem(value).textColor;
}
Vue.filter('returnOrderStatusTextColor', returnOrderStatusTextColor);


export default {
  maxValue,
  limitAll: 10000000,
  cancelFlgs,
  return_order: {
    status: returnOrderStatus,
  },
  dateTimeRangeShortcuts: [
    {
      text: i18n.t("$datetime.shortcuts.today"),
      onClick: () => {
        return [getDayStart(), getDayEnd()];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.yesterday"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 1);
        end.setDate(end.getDate() - 1);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(from.getDate() - 6);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.inOneMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(from.getMonth() - 1);
        from.setDate(from.getDate() + 1);
        return [from, end];
      },
    },
    // {
    //   text: i18n.t("$datetime.shortcuts.inHalfYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setMonth(from.getMonth() - 6);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    // {
    //   text: i18n.t("$datetime.shortcuts.inOneYear"),
    //   onClick: () => {
    //     const from = getDayStart();
    //     const end = getDayEnd();
    //     from.setFullYear(from.getFullYear() - 1);
    //     from.setDate(from.getDate() + 1);
    //     return [from, end];
    //   },
    // },
    {
      text: i18n.t("$datetime.shortcuts.thisWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
           day = 7
         }
        from.setDate(from.getDate() - day + 1);
        end.setDate(end.getDate() + 7 - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastWeek"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        var day = from.getDay()
        if (day == 0) {
          day = 7
        }
        from.setDate(from.getDate() - 6 - day);
        end.setDate(end.getDate() - day);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        end.setMonth(end.getMonth() + 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastMonth"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setDate(1);
        from.setMonth(from.getMonth() - 1);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.thisYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        end.setFullYear(end.getFullYear() + 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
    {
      text: i18n.t("$datetime.shortcuts.lastYear"),
      onClick: () => {
        const from = getDayStart();
        const end = getDayEnd();
        from.setMonth(0);
        from.setDate(1);
        from.setFullYear(from.getFullYear() - 1);
        end.setMonth(0);
        end.setDate(0);
        return [from, end];
      },
    },
  ],
}